import { FC } from 'react';
import { matchPath, useHistory } from 'react-router';
import { Flex } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import ProgressBar from 'components/_core/ProgressBar';

import locales from './locales';

type Step = {
  isNextStepAllowed: boolean;
  nextStepURL: string;
  stepPath: string;
};

type FormProgressionBarProps = {
  steps: Step[];
  currentPath: string;
};

const FormProgressionBar: FC<FormProgressionBarProps> = ({
  currentPath,
  steps,
}) => {
  const history = useHistory();

  const currentStepIndex = steps.findIndex(
    (step) =>
      !!matchPath(currentPath, {
        exact: true,
        path: step.stepPath,
        strict: true,
      }),
  );

  const currentStep = steps[currentStepIndex];

  const ratio = currentStepIndex / steps.length + 1 / steps.length;

  return (
    <Flex alignItems="end" direction="column" marginTop="auto">
      <ProgressBar ratio={ratio} />

      <Button
        // @ts-expect-error currentStep is possibly 'undefined'.
        isDisabled={!currentStep.isNextStepAllowed}
        marginY="space-16"
        onClick={() => {
          // @ts-expect-error currentStep is possibly 'undefined'.
          if (currentStep.isNextStepAllowed) {
            // @ts-expect-error currentStep is possibly 'undefined'.
            history.push(currentStep.nextStepURL);
          }
        }}
        visibility={currentStepIndex === 0 ? 'hidden' : 'visible'}
        width="fit-content"
      >
        {locales.next}
      </Button>
    </Flex>
  );
};

export default FormProgressionBar;
